// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Sibling imports
const {
  SHOW,
  HIDE,
  HEADER_IMAGE_UPLOAD_PENDING,
  HEADER_IMAGE_UPLOAD_FAILED,
  HEADER_IMAGE_UPLOAD_SUCCESS,
  COLLECTION_UPDATE_FAILED,
  COLLECTION_UPDATE_PENDING,
  COLLECTION_UPDATE_SUCCESS,
  COLLECTION_DELETE_FAILED,
  COLLECTION_DELETE_PENDING,
  COLLECTION_DELETE_SUCCESS
} = require('./actions')
const CollectionEditModalRecord = require('./record')

// eslint-disable-next-line complexity
function collectionEditModalReducer(
  state = new CollectionEditModalRecord(),
  { type, payload }
) {
  if (type === SHOW) {
    return new CollectionEditModalRecord({
      collection: payload
    })
  }
  // All other actions only matter after SHOW
  if (!state) {
    return state
  }
  switch (type) {
    // Visibility
    case COLLECTION_DELETE_SUCCESS:
    case HIDE:
      return null
    case HEADER_IMAGE_UPLOAD_PENDING:
      return state.mergeDeep({
        headerImageUploadState: FetchStateEnum.LOADING
      })
    // Image upload
    case HEADER_IMAGE_UPLOAD_FAILED:
      return state.mergeDeep({
        headerImageUploadState: FetchStateEnum.FAILED
      })
    case HEADER_IMAGE_UPLOAD_SUCCESS:
      return state.mergeDeep({
        collection: payload,
        headerImageUploadState: FetchStateEnum.LOADED
      })
    // Collection update status
    case COLLECTION_UPDATE_PENDING:
      return state.merge({
        collectionUpdateState: FetchStateEnum.LOADING
      })
    case COLLECTION_UPDATE_FAILED:
      return state.merge({
        collectionUpdateState: FetchStateEnum.FAILED
      })
    case COLLECTION_UPDATE_SUCCESS:
      return state.mergeDeep({
        collection: payload,
        collectionUpdateState: FetchStateEnum.LOADED
      })
    // Collection remove status
    case COLLECTION_DELETE_PENDING:
      return state.merge({
        collectionDeleteState: FetchStateEnum.LOADING
      })
    case COLLECTION_DELETE_FAILED:
      return state.merge({
        collectionDeleteState: FetchStateEnum.FAILED
      })
    default:
      return state
  }
}

module.exports = collectionEditModalReducer
